import { ISnackbarSuccess } from './types';
import { Dispatch } from '../../../../../types/actions';
import { SNACKBAR_BUTTON_OK } from '../constants';
import { getDefaultActionEvent } from '../helpers/getDefaultActionEvent';
import { addUpdateSnackbarWithBubble } from '../addUpdateSnackbarWithBubble/addUpdateSnackbarWithBubble';
import { SNACKBAR_TIMER_INFO } from '../../hocs/SnackbarHOC/constants';
import { SnackbarVariant } from '../../store/types';

export const snackbarSuccessDefault = (
    options: ISnackbarSuccess
) => {
    return (dispatch: Dispatch) => {
        const shouldUseControlsDefault = options.buttons === undefined;
        if (shouldUseControlsDefault) {
            options.buttons = [{
                onClick: () => dispatch(getDefaultActionEvent(options.id)),
                text: SNACKBAR_BUTTON_OK,
                isTimer: true,
            }];
        }
        if (options.timer === undefined) options.timer = SNACKBAR_TIMER_INFO;
        dispatch(addUpdateSnackbarWithBubble({
            ...options,
            variant: SnackbarVariant.SUCCESS,
            onTimer: () => dispatch(getDefaultActionEvent(options.id)),
        }));
    }
};
